import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('EmptyView', [
  'description',
  'supportText',
  'actions',
]);

const getEmptyViewCss = css`
  padding: var(--cds-spacing-300);
  border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  border-top: none;
  border-bottom-left-radius: var(--cds-border-radius-200);
  border-bottom-right-radius: var(--cds-border-radius-200);

  > div {
    max-width: 568px;
    text-align: center;
    margin: var(--cds-spacing-200) auto;
  }

  .${classes.supportText} {
    margin-top: var(--cds-spacing-50);
  }

  .${classes.description} {
    margin: var(--cds-spacing-200);
    color: var(--cds-color-neutral-primary-weak);
  }

  .${classes.actions} {
    margin: var(--cds-spacing-300) var(--cds-spacing-600) var(--cds-spacing-600)
      var(--cds-spacing-600);

    > * {
      margin: 0 auto;
      width: fit-content;
    }
  }
`;

export default getEmptyViewCss;
